// extracted by mini-css-extract-plugin
export default {"changeQuestion":"styles_changeQuestion__xdKO+","show":"styles_show__adFx0","nonVertical":"styles_nonVertical__cKVbx"};